export default __webpack_public_path__ + "static/media/search.ab61e00e.svg";